import { render, staticRenderFns } from "./BatchDramaReviewsAddDetail.vue?vue&type=template&id=62dfcc3f&scoped=true"
import script from "./BatchDramaReviewsAddDetail.vue?vue&type=script&lang=js"
export * from "./BatchDramaReviewsAddDetail.vue?vue&type=script&lang=js"
import style0 from "./BatchDramaReviewsAddDetail.vue?vue&type=style&index=0&id=62dfcc3f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dfcc3f",
  null
  
)

export default component.exports